import { gql } from 'graphql-request';

import {
  ItemTagCreatedAt,
  ItemTagID,
  ItemTagName,
  ItemTagNanoID,
  ItemTagUpdatedAt,
  ItemTagUUID
} from '../itemTagsTypes';

export interface FetchCacheItemTagsQueryResponse {
  id: ItemTagID;
  uuid: ItemTagUUID;
  nanoId: ItemTagNanoID;
  createdAt: ItemTagCreatedAt;
  updatedAt: ItemTagUpdatedAt;
  name: ItemTagName;
  type: string;
  userId: number;
  companyId: number | null;
}

export const FETCH_CACHE_ITEM_TAGS_QUERY = gql`
  query CacheItemTags(
    $filters: ItemTagsFilters
    $limit: Int
    $offset: Int
    $sort: [ItemTagsSortEnum!]
    $source: String
  ) {
    itemTags(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
    ) {
      nodes {
        id
        uuid
        nanoId
        createdAt
        updatedAt
        name
        type
        userId
        companyId
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
